import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage.js';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Authenticate user
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} /> 
      </Routes>
    </BrowserRouter>
  );
}

export default App;